import React, { useContext } from 'react';
import { CanduTutorialContextType } from '@candulabs/core';

export const TutorialContext = React.createContext<CanduTutorialContextType | null>(null);

export const useTutorialContext = (): CanduTutorialContextType | null =>
  useContext(TutorialContext);
